import React from "react";
import PropTypes from "prop-types";
import SearchableSelect from "../../SearchableSelect.component";

export default function LicenseSelect({ id, options, value = "", onChange, placeholder = "Select license..." }) {
  return (
    <SearchableSelect
      id={id}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      fullWidth
      multiple={false}
      clearButtonLabel="Clear license selection"
      filterPlaceholder="Type to filter..."
      noResultsText="No results found"
      listAriaLabel="License options"
    />
  );
}

LicenseSelect.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};
